
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState(['order','location','handoff']),
    }
  }
